document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll('.main-mega-menu-list-item:not(.main-mega-menu-last-item)');

    menuItems.forEach(item => {
        const submenu = item.querySelector('.main-mega-menu-sub-menu');
        const link = item.querySelector('.main-link-item'); 
        let openedByClick = false;

        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        if (isTouchDevice && link) {
            link.addEventListener('click', (event) => {
                event.preventDefault(); 

                if (item.classList.contains('mega-menu-opened')) {
                    item.classList.remove('mega-menu-opened');
                    openedByClick = false;
                } else {
                    document.querySelectorAll('.mega-menu-opened').forEach(opened => {
                        if (opened !== item) {
                            opened.classList.remove('mega-menu-opened');
                        }
                    });

                    item.classList.add('mega-menu-opened');
                    openedByClick = true;
                }
            });
        }

        item.addEventListener('mouseenter', () => {
            if (!isTouchDevice) {
                document.querySelectorAll('.mega-menu-opened').forEach(opened => {
                    if (opened !== item) {
                        opened.classList.remove('mega-menu-opened');
                    }
                });

                if (!openedByClick) {
                    item.classList.add('mega-menu-opened');
                }
            }
        });

        item.addEventListener('mouseleave', (event) => {
            if (!isTouchDevice && (submenu && submenu.contains(event.relatedTarget)) || openedByClick) {
                return;
            }
            item.classList.remove('mega-menu-opened');
        });

        document.addEventListener('click', (event) => {
            if (!item.contains(event.target)) {
                item.classList.remove('mega-menu-opened');
                openedByClick = false;
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll('.main-mega-menu-sub-menu-item.main-mega-menu-sub-menu-item-megasubmenu');
    let activeItem = null;
    let isTouchDevice = false;

    const detectTouch = () => {
        isTouchDevice = true;
        window.removeEventListener('touchstart', detectTouch);
    };

    window.addEventListener('touchstart', detectTouch);

    menuItems.forEach(item => {
        const subMenu = item.querySelector('.main-mega-menu-item-nav');

        const adjustMinHeight = () => {
            const currentHeight = item.offsetHeight;
            const subMenuHeight = subMenu ? subMenu.offsetHeight : 0;
            item.style.minHeight = `${currentHeight + subMenuHeight}px`;
        };

        const resetMinHeight = () => {
            item.style.minHeight = '0';
        };

        const openSubMenu = () => {
            if (item.classList.contains('open')) return;

            document.querySelectorAll('.main-mega-menu-sub-menu-item.main-mega-menu-sub-menu-item-megasubmenu.open').forEach(openItem => {
                if (openItem !== item) {
                    openItem.classList.remove('open');
                    openItem.style.minHeight = '0';
                }
            });

            item.classList.add('open');
            adjustMinHeight();
            activeItem = item;
        };

        const closeSubMenu = () => {
            if (!item.classList.contains('open')) return;

            item.classList.remove('open');
            resetMinHeight();
            if (activeItem === item) activeItem = null;
        };

        item.addEventListener('mouseenter', () => {
            if (!isTouchDevice) openSubMenu();
        });

        item.addEventListener('mouseleave', (event) => {
            if (!isTouchDevice && !subMenu.contains(event.relatedTarget)) {
                closeSubMenu();
            }
        });

        item.addEventListener('click', (event) => {
            const link = event.target.closest('a'); 
            if (link) {
                return; 
            }

            event.preventDefault();

            if (item.classList.contains('open')) {
                closeSubMenu();
            } else {
                openSubMenu();
            }
        });

        document.addEventListener('click', (event) => {
            if (activeItem && !activeItem.contains(event.target)) {
                activeItem.classList.remove('open');
                activeItem.style.minHeight = '0';
                activeItem = null;
            }
        });
    });
});